// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"272":"842961ef","945":"7288d49e"}[chunkId] + ".js";
};